import type { RequestConfig } from '@bayes-mes/shared/api/core/client';

export function buildPatchRequestConfig(data?: any, config?: RequestConfig) {
  return {
    ...config,
    data,
    method: 'PATCH' as const,
  };
}
